import {combineReducers} from 'redux';
import auth from './components/public/auth/auth-reducer';
import cashBids from './components/private/cash-bids/cashBids-reducer';
import userSettings from './shared/reducers/userSettings';
import weatherStations from './components/private/weather-stations/weatherStations-reducer';
import reports from './components/private/reports/reports-reducer';
import mapping from './components/private/mapping/mapping-reducer';
import agronomy from './components/private/agronomy/agronomy-reducer';
import toolBox from './components/private/tool-box/tool-box-reducer';
import carbonScoring from './components/private/tool-box/carbon-scoring-reducer';
import marketingPlan from './components/private/marketing-plan/marketingPlan-reducer';

export default combineReducers({
  auth,
  cashBids,
  userSettings,
  weatherStations,
  reports,
  mapping,
  agronomy,
  toolBox,
  carbonScoring,
  marketingPlan,
});